(function () {
  const storageKey = 'wc_wishlist_products';

  function getWishlist() {
    try {
      const raw = localStorage.getItem(storageKey);
      const items = JSON.parse(raw) || [];

      if (!Array.isArray(items)) {
        return [];
      }

      return Array.from(new Set(items.filter(Boolean)));
    } catch (error) {
      return [];
    }
  }

  function updateWishlistCounters(itemsFromEvent) {
    const items = Array.isArray(itemsFromEvent) ? itemsFromEvent : getWishlist();
    const count = items.length;

    document.querySelectorAll('[data-wc-wishlist-count-badge]').forEach((badge) => {
      badge.textContent = String(count);

      if (count > 0) {
        badge.hidden = false;
        badge.removeAttribute('hidden');
      } else {
        badge.hidden = true;
        badge.setAttribute('hidden', '');
      }
    });
  }

  function initWishlistCounters() {
    updateWishlistCounters();

    setTimeout(updateWishlistCounters, 250);
    setTimeout(updateWishlistCounters, 750);
    setTimeout(updateWishlistCounters, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistCounters);
  } else {
    initWishlistCounters();
  }

  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) {
      updateWishlistCounters();
    }
  });

  window.addEventListener('wc:wishlist:updated', (event) => {
    updateWishlistCounters(event.detail && event.detail.items);
  });

  document.addEventListener('click', () => {
    setTimeout(updateWishlistCounters, 80);
  });

  window.addEventListener('focus', updateWishlistCounters);
})();